import { API } from "config";
import request from "utilities/request";
import type { McpConfig } from "types/Mcp";
import type { ToolDefinition } from "types/longTask";

const baseUrl = API.cortevaChain.url;

/**
 * Fetches the active persona's MCP tool definitions (including each tool's
 * `_meta` block) by POSTing the MCP config to `/chat/tools`. Uses the shared
 * `request` wrapper so error/CORS handling matches the rest of the app.
 * Returns an empty list when the response carries no `tools` array.
 */
export async function fetchTools(
  mcpConfig: McpConfig,
  getAccessToken: () => Promise<string>
): Promise<ToolDefinition[]> {
  const accessToken = await getAccessToken();

  const url = `${baseUrl}/chat/tools`;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${accessToken}`,
  };
  const options = {
    method: "POST",
    headers,
    body: JSON.stringify({ mcp_config: mcpConfig }),
  };

  const response = await request(url, options);
  const data = await response.json();
  return Array.isArray(data.tools) ? (data.tools as ToolDefinition[]) : [];
}
